module.exports = __webpack_public_path__ + "img/c05_buildingtechabacus_Normal_ua.8d2805f7.webp";